import {useState} from "react";
import {useNavigate} from "react-router-dom";

const LeagueAppAccessTool = () => {
    const [leagueId, setLeagueId] = useState('');
    const navigate = useNavigate();

    return (
        <div>
            <input value={leagueId} onChange={(event) => setLeagueId(event.target.value)}/>
            <button onClick={() => navigate(`/app/league/${leagueId}/dashboard`)}>Access League</button>
        </div>
    );
}

export default LeagueAppAccessTool;